import { CertificadoService } from '../../services/certificado.service';
import { Component, OnInit, ViewChild, EventEmitter, Output, Input, ElementRef } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import * as forge from 'node-forge';
import { arrayBufferToString } from '../../util/format';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-modal-certificado-gerar-confirmar',
  templateUrl: './modal-certificado-gerar-confirmar.component.html',
  styleUrls: ['./modal-certificado-gerar-confirmar.component.scss'],
})
export class ModalCertificadoGerarConfirmarComponent implements OnInit {

  @Input() corPrimaria: string;
  @Input() nuCnpjFms: string;
  @Output() fecharModal = new EventEmitter();

  form: FormGroup = this.formBuilder.group({
    senha: new FormControl(null, Validators.required),
    confirmacao: new FormControl(null, Validators.required),
  });

  fileReader = new FileReader();

  regra_minuscula = false;
  regra_maiuscula = false;
  regra_numero = false;
  regra_simbulos = false;
  regra_tamanho = false;
  regra_igualdade = false;
  regra_maior_tamanho = true;

  constructor(
    private formBuilder: FormBuilder,
    private toast: ToastrService,
    private loading: NgxSpinnerService,
    private certificadoService: CertificadoService
  ) {

  }

  ngOnInit() {

    console.log('nuCnpjFms', this.nuCnpjFms);

  }

  validar() {
    if (!this.form.valid) {
      this.toast.error('Preencha os campos obrigatórios.');
      return;
    }

    if (this.regra_minuscula == false ||
      this.regra_maiuscula == false ||
      this.regra_numero == false ||
      this.regra_simbulos == false ||
      this.regra_tamanho == false ||
      this.regra_igualdade == false ||
      this.regra_maior_tamanho == false) {
      this.toast.error('Sua senha deve respeitar os critérios.');
      return;
    }

    this.loading.show();
    this.certificadoService.download(this.nuCnpjFms, this.form.value.senha).then(retorno => {
      retorno.certificate = this.gerarCertificate(retorno.content);
      this.loading.hide();
      this.fechar({
        revogar: false,
        retorno
      });
    }).catch(err => {
      this.loading.hide();
      this.fechar({
        revogar: true,
        err
      });
    });
  }

  gerarCertificate(pkcs12B64) {
    let pkcs12Der64 = forge.util.decode64(pkcs12B64);
    let pkcs12Asn1 = forge.asn1.fromDer(pkcs12Der64);
    let pkcs12 = forge.pkcs12.pkcs12FromAsn1(pkcs12Asn1, false, this.form.value.senha);
    const certBags = pkcs12.getBags({ bagType: forge.pki.oids.certBag })[forge.pki.oids.certBag];

    return forge.pki.certificateToPem(certBags[0].cert);
  }

  validadePassword() {

    console.log('entrei');
    this.regra_minuscula = false;
    this.regra_maiuscula = false;
    this.regra_numero = false;
    this.regra_simbulos = false;
    this.regra_tamanho = false;
    this.regra_igualdade = false;
    this.regra_maior_tamanho = true;

    if ((/^(?=.*[a-z])/g).test(this.form.value.senha)) {
      this.regra_minuscula = true;
    }

    if ((/^(?=.*[A-Z])/g).test(this.form.value.senha)) {
      this.regra_maiuscula = true;
    }

    if ((/^(?=.*\d)/g).test(this.form.value.senha)) {
      this.regra_numero = true;
    }

    if ((/^(?=.*[!@#$%&*])/g).test(this.form.value.senha)) {
      this.regra_simbulos = true;
    }

    if ((/^[A-Za-z\d!@#$%&*]{6,8}/g).test(this.form.value.senha)) {
      this.regra_tamanho = true;
    }

    if (this.form.value.senha.length > 8) {
      this.regra_maior_tamanho = false;
    }

    if ((this.form.value.senha === this.form.value.confirmacao) && this.regra_tamanho) {
      this.regra_igualdade = true;
    }
  }

  fechar(data?) {
    this.fecharModal.emit(data);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/modal-certificado-gerar-confirmar/modal-certificado-gerar-confirmar.component.ts